import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=4e7d3060&scoped=true&"
import script from "./AppButton.vue?vue&type=script&lang=js&"
export * from "./AppButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d3060",
  null
  
)

export default component.exports